export default __webpack_public_path__ + "static/media/modifications.932e9034.jpg";